var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangularOp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 0H0V23H10.4437C12.3457 23 14.1698 22.2444 15.5146 20.8996C16.4547 19.9596 17.0215 18.7103 17.11 17.3839L18.0339 3.5254L13.3333 0ZM12.6667 2L15.9661 4.4746L15.1144 17.2508C15.0582 18.0939 14.6979 18.8879 14.1004 19.4854C13.1306 20.4552 11.8153 21 10.4437 21H2V2H12.6667Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600016 0.7C0.43433 0.920914 0.479101 1.23431 0.700016 1.4L4.50002 4.25V16.5C4.50002 17.9164 3.83314 19.2502 2.70002 20.1L0.700016 21.6C0.479101 21.7657 0.43433 22.0791 0.600016 22.3C0.765701 22.5209 1.0791 22.5657 1.30001 22.4L3.30002 20.9C4.68495 19.8613 5.50002 18.2312 5.50002 16.5V4.5H17C17.2762 4.5 17.5 4.27614 17.5 4C17.5 3.72386 17.2762 3.5 17 3.5H5.16668L1.30001 0.6C1.0791 0.434314 0.765701 0.479086 0.600016 0.7Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangularOp);
export default __webpack_public_path__ + "static/media/rectangular-op.9856bd8a.svg";
export { ForwardRef as ReactComponent };